import { j as t } from "./index58.mjs";
import { ActionIcon as s, ThemeIcon as m } from "@mantine/core";
import { forwardRef as v } from "react";
import { rgba as a } from "./index8.mjs";
import { Tooltip as b } from "./index17.mjs";
const x = (r, i) => i.variant === "transparent" ? {
  "&:hover": {
    background: a(r, 5, 0.2, i)
  }
} : i.variant === "filled" ? {
  background: a(r, 8, 0.9, i),
  border: `1px solid ${a(r, 8, 0.9, i)}`,
  "&:hover": {
    background: a(r, 8, 1, i)
  }
} : i.variant === "light" ? {
  background: a(r, 6, 0.4, i),
  "&:hover": {
    background: a(r, 6, 0.6, i)
  }
} : {}, A = v(
  (r, i) => {
    const { active: u, gradient: f, tooltip: e, ...d } = r, c = "dark", l = "transition " + r.className, n = {
      size: "md",
      variant: "filled",
      color: c,
      radius: "sm",
      p: 4,
      style: {},
      sx: (g) => x(g, {
        color: c,
        ...r
      })
    };
    if (f)
      return /* @__PURE__ */ t.jsx(
        s,
        {
          ...n,
          ...d,
          ref: i,
          className: l,
          p: 0,
          variant: "transparent",
          children: /* @__PURE__ */ t.jsx(
            m,
            {
              style: { backgroundOrigin: "border-box" },
              size: r.size || n.size,
              radius: r.radius || n.radius,
              p: r.p || n.p,
              variant: "gradient",
              gradient: { from: "indigo", to: "pink", deg: 60 },
              children: r.children
            }
          )
        }
      );
    let o = /* @__PURE__ */ t.jsx(
      s,
      {
        ...n,
        ...d,
        ref: i,
        className: l,
        variant: u ? "filled" : r.variant || n.variant
      }
    );
    return e && (o = /* @__PURE__ */ t.jsx(b, { label: e, children: o })), o;
  }
);
export {
  A as ActionIcon
};
